<template>
  <div class="approver-config">
    <el-dialog
      :model-value="visible"
      class="dialog-inner-scroller min-h-[169px]"
      align-center
      :before-close="close"
      width="460"
    >
      <template #header>
        <h4>
          {{ approveStatusLabel[status] }}
        </h4>
      </template>
      <el-scrollbar always>
        <el-form
          ref="formRef"
          require-asterisk-position="right"
          class="add-platform-users-form"
          label-position="top"
          :model="form"
        >
          <el-form-item
            label="审批备注"
            class="!mb-0"
          >
            <el-input
              v-model="form.remark"
              placeholder="请输入审批备注"
              type="textarea"
              :rows="3"
              class="w-[432px]"
            />
          </el-form-item>
        </el-form>
      </el-scrollbar>
      <template #footer>
        <div class="flex justify-end">
          <el-button @click="close">
            取消
          </el-button>
          <el-button type="primary" @click="handleSubmit">
            确定
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import { FormInstance } from 'element-plus';
import { ref, watch } from 'vue';
import { EApproveStatus, approveStatusLabel } from '@core/main/types/common';

const emit = defineEmits(['close', 'confim']);

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  status: {
    type: Number as () => EApproveStatus,
    default: EApproveStatus.SUCCESS,
  },
});

const formRef = ref<FormInstance>();
const form = ref({ remark: undefined });

async function doSubmit() {
  emit('confim', form.value.remark);
  close();
}

function handleSubmit() {
  formRef.value.validate((valid) => {
    if (valid) doSubmit();
  });
}

function close() {
  form.value.remark = undefined;
  emit('close');
}

watch(
  () => props.visible,
  () => {
    if (props.visible) {

    }
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped>
.approver-config {
  :deep(.el-dialog) {
    @apply p-0;

    .el-dialog__footer {
      @apply px-6 py-4;
    }

    .el-dialog__body {
      @apply px-0 pb-4;

      .el-select__wrapper {
        @apply h-[40px];
      }

      .el-scrollbar__view {
        @apply max-h-[300px] px-6;
      }
    }

    .el-dialog__header {
      @apply px-6 py-4;
    }
  }
}
</style>
